var map = {
	"./1-1.jpg": 382,
	"./33.jpg": 767,
	"./44.jpg": 769,
	"./Diya-Making-1.jpg": 7064,
	"./Diya-Making-3.jpg": 7450,
	"./Diya-Making-4.jpg": 3289,
	"./Diya-Making-5.jpg": 5500,
	"./Diya-Making.jpg": 4130,
	"./Drinking-Water.jpg": 8481,
	"./Food.jpg": 4881,
	"./Picnic-1.jpg": 4789,
	"./Picnic-10.jpg": 9657,
	"./Picnic-11.jpg": 2780,
	"./Picnic-12.jpg": 7435,
	"./Picnic-16.jpg": 679,
	"./Picnic-17.jpg": 2938,
	"./Picnic-18.jpg": 4049,
	"./Picnic-19.jpg": 2244,
	"./Picnic-2-1-rotated.jpg": 204,
	"./Picnic-20.jpg": 8008,
	"./Picnic-21.jpg": 7554,
	"./Picnic-3-1.jpg": 8585,
	"./Picnic-4-1.jpg": 8626,
	"./Picnic-5-1.jpg": 3251,
	"./Picnic-6.jpg": 9166,
	"./Picnic-7.jpg": 3563,
	"./Picnic-8.jpg": 9280,
	"./Picnic-9.jpg": 4173,
	"./Students-Hygiene-1.jpg": 8841,
	"./Students-Hygiene-3.jpg": 3595,
	"./Students-Hygiene.jpg": 4103,
	"./Workshop-Hostel.jpg": 6068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9872;